import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import uniqueId from 'lodash/uniqueId';
import { PapiUser } from '@wix/da-types-papi';
import { AppState } from '../../../types/store';
import {
  getProfileOwner,
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
  isViewingAsVisitor,
} from '../../selectors/users';
import { actions as modalActions } from '@wix/da-shared-react/pkg/Modals';
import { getIsLoggedIn } from '@wix/da-shared-react/pkg/publicSession';
import { restrictLoggedOut } from '@wix/da-shared-react/pkg/redux/loggedout/actionCreators';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags';
import { startNewChatWithParticipant } from '@wix/da-shared-react/pkg/ChatV2/redux/actions';
import {
  fetchProfileOwnerGiveState,
  fetchProfileOwnerGiveStateSuccess,
} from '../../actions/profileOwner';
import { biClickProfileNavBar } from '../../actions/bi';
import { sectionRoutes } from '../../routes';
import { SubNavBarProps } from './SubNavBar';

type StateProps = Pick<
  SubNavBarProps,
  | 'isOwner'
  | 'isViewingAsVisitor'
  | 'isLoggedIn'
  | 'giveState'
  | 'profileOwnerUser'
  | 'routes'
>;
type DispatchProps = Pick<
  SubNavBarProps,
  | 'pushBadgeModal'
  | 'pushPointsModal'
  | 'initGiveState'
  | 'onLlamaBadgeSent'
  | 'onCakeBadgeSent'
  | 'onStartChat'
  | 'restrictLoggedOut'
  | 'biClickProfileNavBar'
>;
type OwnProps = Omit<SubNavBarProps, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const isOwner = isCurrentUserProfileOwner(state);

  return {
    isOwner,
    giveState: getProfileOwner(state).giveState,
    profileOwnerUser: getProfileOwnerUser(state),
    isLoggedIn: getIsLoggedIn(state),
    routes: sectionRoutes.filter(route => {
      if (
        route.featureProtected &&
        !flagEnabled(state, route.featureProtected)
      ) {
        return false;
      }
      return isOwner || !route.isForOwnerOnly;
    }),
    isViewingAsVisitor: isViewingAsVisitor(state),
  };
};

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  pushBadgeModal: (name, userId, title, onBadgeSent) =>
    dispatch(modalActions.pushBadgeModal(name, userId, title, '', onBadgeSent)),
  pushPointsModal: (userId, title) =>
    dispatch(modalActions.pushPointsModal(userId, title)),
  initGiveState: () => dispatch(fetchProfileOwnerGiveState()),
  onLlamaBadgeSent: () =>
    dispatch(fetchProfileOwnerGiveStateSuccess({ canBeGivenLlama: false })),
  onCakeBadgeSent: () =>
    dispatch(fetchProfileOwnerGiveStateSuccess({ canBeGivenCake: false })),
  onStartChat: (user: PapiUser) =>
    dispatch(
      startNewChatWithParticipant(uniqueId('new-chat-request'), {
        id: user.useridUuid,
        name: user.username,
      })
    ),
  restrictLoggedOut: payload => dispatch(restrictLoggedOut(payload)),
  biClickProfileNavBar: linkName => dispatch(biClickProfileNavBar(linkName)),
});

export default connect(mapStateToProps, mapDispatchToProps);
